'use strict';

const getLastNotification = state => {
  return state.lastNotification;
};

export default {
  getLastNotification
};
